import {OnebillPaymentComponent} from "./onebill-payment/onebill-payment.component";
import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {BuyerComponent} from "./buyer/buyer.component";
import {CheckoutComponent} from "./checkout/checkout.component";
import {OrdersComponent} from "./orders/orders.component";
import {ListRFQComponent} from "./list-rfq/list-rfq.component";
import {OnebillCheckoutComponent} from "./onebill-checkout/onebill-checkout.component";
import {BuyerAuthGuard} from "./buyer-auth-guard";
import {UpdateUserComponent} from "./user/update-user/update-user.component";
import {UpdatePasswordComponent} from "./user/update-password/update-password.component";
import {AccountStatusComponent} from "./user/account-status/account-status.component";
import {NotificationsListComponent} from "./notifications/notifications-list/notifications-list.component";
import { EditRfqComponent } from './edit-rfq/edit-rfq.component';
import {CommerceComponent} from "./commerce/commerce.component";

const routes: Routes = [
  {
    path: 'buyer', component: BuyerComponent, canActivate: [BuyerAuthGuard],
    children: [
      {path: '', component: CommerceComponent}, //TODO: replace this with buyer dashboard home
      {path: 'rfqs-list', component: ListRFQComponent},
      {path: 'checkout', component: CheckoutComponent},
      {path: 'orders', component: OrdersComponent},
      {path: 'request-for-quotations', component: ListRFQComponent},
      {path: 'edit-rfq/:id', component: EditRfqComponent},
      {path: 'onebill-payment', component: OnebillPaymentComponent},
      {path: 'user/update', component: UpdateUserComponent},
      {path: 'user/update-password', component: UpdatePasswordComponent},
      {path: 'user/account-status', component: AccountStatusComponent},
      {path: 'notifications-list', component: NotificationsListComponent},
      {path: 'commerce', component: CommerceComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  providers: []
})
export class BuyerRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/buyer-routing.module.ts